module.exports = __webpack_public_path__ + "01_bob_gold.f9a26b68.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/01_bob_gold.png
// module id = YsMX
// module chunks = 0